var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkEmployment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#F3F4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 20.2H16C15.5582 20.2 15.2 20.5582 15.2 21V36C15.2 36.4418 15.5582 36.8 16 36.8H37C37.4418 36.8 37.8 36.4418 37.8 36V21C37.8 20.5582 37.4418 20.2 37 20.2ZM16 19C14.8954 19 14 19.8954 14 21V36C14 37.1046 14.8954 38 16 38H37C38.1046 38 39 37.1046 39 36V21C39 19.8954 38.1046 19 37 19H16Z",
    fill: "#787395"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 17.2H23C22.5582 17.2 22.2 17.5582 22.2 18V18.8H30.8V18C30.8 17.5582 30.4418 17.2 30 17.2ZM23 16C21.8954 16 21 16.8954 21 18V20H32V18C32 16.8954 31.1046 16 30 16H23Z",
    fill: "#787395"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2 27.2V28.8H29.8V27.2H23.2ZM23 26C22.4477 26 22 26.4477 22 27V29C22 29.5523 22.4477 30 23 30H30C30.5523 30 31 29.5523 31 29V27C31 26.4477 30.5523 26 30 26H23Z",
    fill: "#787395"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4211 20.1583L15.5787 19.8418L17.6454 27.4001H21.9999V28.6H16.7294L14.4211 20.1583Z",
    fill: "#787395"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5789 20.1583L37.4213 19.8418L35.3546 27.4001H31.0001V28.6H36.2706L38.5789 20.1583Z",
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkEmployment);
export default __webpack_public_path__ + "static/media/link-employment.002881a7.svg";
export { ForwardRef as ReactComponent };